import moment from 'moment'
import QRCode from 'qrcode'

/**
 * 生成二维码
 * @param {String} url
 *
 */
export const createQRCode = (url) => {
  return new Promise((resolve) => {
    QRCode.toDataURL(url)
      .then((base64Image) => {
        resolve(base64Image)
      })
      .catch((err) => {
        resolve(err)
      })
  })
}

// 数字金额增加逗号
export const addDot = (num) => {
  if (num === 0 || num === '0' || num === '') {
    return ''
  }

  num = num.toString()
  let result = ''
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`

    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  return result
}
// 数字转 英文序数词缩写后缀
export const ordinalNumber = (n) => {
  return n + (['st', 'nd', 'rd'][n < 20 ? n - 1 : (n % 10) - 1] || 'th')
}

// 几年几届中转英
export const cycleEnglish = (str) => {
  const year = Number(str[0])
  const jie = Number(str[2])
  let jieText = ''
  if (jie === 1) {
    jieText = 'Once'
  }
  if (jie === 2) {
    jieText = 'Twice'
  }
  if (jie >= 3) {
    jieText = `${jie} times`
  }
  return `${jieText} ${year > 1 ? `${year}years` : 'a year'}`
}
// 小数点前
// export const trunc = (num) => {
//   if (num >= 0) return Math.floor(num)
//   return Math.ceil(num)
// }

// // 小数点后
// export const fract = (num) => {
//   return num - Math.trunc(num) || ''
// }

/**
 * 前后端数据结构转换的方法
 *
 */
// 前端转后端数据,（对象转换成的数组对象） （多行文本值和富文本编辑器值）
export const richTextToBack = (obj) => {
  const arr = []
  for (const [key, value] of Object.entries(obj)) {
    let descValue = ''
    if (value) {
      descValue = value
    }
    arr.push({
      descKey: key,
      // white-space: pre-wrap;解决【空格】没有如输入的内容一样
      descValue,
    })
  }
  return arr
}

// 后端数据转前端,（数组对象转换成的对象） （多行文本值和富文本编辑器值）
export const richTextTofront = (arrObj) => {
  const obj = {}
  arrObj.map((k) => {
    obj[k.descKey] = k.descValue
  })
  return obj
}

/**
 * 判断开幕时间和服务器时间,返回状态 【待开幕|进行中|已结束】
 * @param {*} beginTime 开幕时间
 * @param {*} endTime 闭幕时间
 * @param {*} serverTime 服务器时间
 */
export const isExStatus = (beginTime, endTime, serverTime) => {
  // console.log(beginTime, endTime, serverTime)
  let time = serverTime
  if (!time) {
    time = new Date()
  }
  // 判断开幕时间 和服务器时间
  const flag = moment(time).isBefore(beginTime)
  // 判断闭幕时间 和服务器时间
  const flag2 = moment(time).isBefore(endTime)
  if (flag) {
    return '待开幕'
  }
  if (flag === false && flag2 === true) {
    return '进行中'
  }
  return '已结束'
}
/**
 * 获取openStatus的中文名称
 * @returns 【1待开幕|2进行中|3已结束】
 */
export const getOpenStatusText = (openStatus) => {
  let str = ''
  switch (openStatus) {
    case 1:
      str = '待开幕'
      break
    case 2:
      str = '进行中'
      break
    case 3:
      str = '已结束'
      break
    default:
      break
  }
  return str
}

/**
 * 给列表数据增加展览状态 待开幕|进行中|已结束
 * @param {*} serverTime 服务器时间
 * @param {*} records 列表数据
 */
export const addExhibitionStatus = (serverTime, records) => {
  for (const item of records) {
    // 计算展览状态
    item.statusTime = isExStatus(item.beginTime, item.endTime, serverTime)
  }
  return records
}

/**
 * 判断传入的数组数据,是否为空,不为空则根据传入的符号,连续字符串返回
 * @param {*} arrData 数组字符串数据
 * @param {*} delimiter 分隔符 默认"-"
 */
export const arrDataJoinString = (arrData, delimiter = '-') => {
  let str = ''
  arrData.map((v, i) => {
    if (v && i !== 0) {
      if (str) {
        str += `${delimiter}${v}`
      } else {
        str += v
      }
    } else if (v) {
      str += v
    }
  })
  return str
}

/**
 * 正则格式化金额
 */
export const moneyToFormt = (money) => {
  return money.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 搜索条件合并, 并去除为空的值
 */
export const getFilterSearchQuery = (newObj, oldObj) => {
  const obj = {}
  /**
   * 过滤value为空的搜索条件
   * Object.assign 两个对象合并
   * Object.entries 转成数组
   */
  for (const [key, value] of Object.entries(Object.assign(oldObj, newObj))) {
    if (value) {
      obj[key] = value
    }
  }
  // console.log('getFilterSearchQuery', obj)
  console.log('合并', obj, Object.assign(oldObj, newObj))
  return obj
}

// export const getFilterSearchQuery = (newObj, oldObj) => {
//   const obj = {
//     ...newObj,
//     ...oldObj
//   }

//   // 过滤value为空的搜索条件
//   // for (const [key, value] of Object.entries(Object.assign(oldObj, newObj))) {
//   //   if (value) {
//   //     obj[key] = value
//   //   }
//   // }
//   // console.log('getFilterSearchQuery', obj)
//   console.log('合并', obj)
//   return Object
//     .keys(obj)
//     .filter(key => obj[key] !== null && obj[key] !== undefined)
//     .reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {})
// }

/**
 * 首页运营位布局
 */
export const goodFlex = (data) => {
  const list = data
  let addSum = 0
  if (list.length < 4) {
    addSum = list.length % 4
  } else {
    addSum = 5 - ((list.length - 4) % 5)
    if (addSum === 5) {
      addSum = 0
    }
  }
  if (addSum) {
    for (let i = 0; i < addSum; i++) {
      list.push({})
    }
  }
  console.log('addSum', addSum)
  return list
}
